import { useStaticQuery, graphql } from "gatsby"
import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const StyledTrashIcon = styled.div``

const StyledTrashImage = styled.div`
    margin: 12px 0;
    width: 13px;
    height: 13px;
    filter: invert(1);
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        cursor: pointer;
        opacity: 0.8;
    }
`

const TrashImage = ({ handlerClick, img, ...props }) => {
    return (
        <div onClick={() => handlerClick()}>
            <StyledTrashImage imgStyle={{ objectFit: "contain" }} fluid={img} />
        </div>
    )
}

const TrashIcon = ({ handlerClick, size }) => {
    const data = useStaticQuery(graphql`
        {
            iconTrash: file(relativePath: { eq: "Icon/trash.png" }) {
                childImageSharp {
                    gatsbyImageData(width: 900, layout: CONSTRAINED)
                }
            }
        }
    `)
    return (
        <StyledTrashImage onClick={() => handlerClick()}>
            <StaticImage src="../../images/Icon/trash.png" alt="Remove" />
        </StyledTrashImage>
    )
}

export default TrashIcon
